module.exports = __webpack_public_path__ + "static/the-spy-who-came-in-from-the-cold-f207214d875d352460636bc60631dac5.jpg";